/** Calculates visual feedback (like colors) for the task focus timer based on elapsed time and duration. */
import { TIMER_WARNING_THRESHOLD } from '@/config/constants';

export const getFocusTimerColor = (
  elapsedMinutes,
  duration,
  { includeWarning = false } = {},
) => {
  if (duration <= 0) return 'var(--color-success, #4B7B5E)';

  if (elapsedMinutes > duration) {
    return 'var(--color-error, #B5473A)';
  }

  if (includeWarning && elapsedMinutes >= duration * TIMER_WARNING_THRESHOLD) {
    return 'var(--color-warning, #D9A441)';
  }

  return 'var(--color-success, #4B7B5E)';
};
